module.exports = __webpack_public_path__ + "static/img/2422_phase_function_Paper_PointsHejduk_Prediction.c1763ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2422_phase_function_Paper_PointsHejduk_Prediction.png
// module id = fx8W
// module chunks = 0